// extracted by mini-css-extract-plugin
export default {"container":"ProductEmailService_container__WzZa5","loading":"ProductEmailService_loading__vWNzG","iframe":"ProductEmailService_iframe__JjPQi"};